/**
 * Epoch milliseconds of a timestamp the services or the backend sent, or null
 * when it is missing or unparseable. A string without a zone designator is
 * UTC: Python's `datetime.now().isoformat()` writes naive strings and pymongo
 * stores them as UTC, while `new Date()` would read them as local time.
 */
export const parseServerTimestampMs = (timestamp?: string | null): number | null => {
  if (!timestamp) return null;
  const hasZone = timestamp.endsWith('Z') || timestamp.includes('+') || timestamp.includes('-', 10);
  const parsedMs = new Date(hasZone ? timestamp : `${timestamp}Z`).getTime();
  return Number.isNaN(parsedMs) ? null : parsedMs;
};
